import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import centralApiAxios from "../../axios/centralApiAxios";
import {
    GET_ADDRESS_LIST
} from '../actions';

import {
    getAddressListSuccess,
    getAddressListError
} from './actions';

export function* watchGetAddressList() {
    yield takeEvery(GET_ADDRESS_LIST, getAddressList);
}

const getAddressListAsync = async (payload) => {
   try {
    // eslint-disable-next-line
    let responseObject = await centralApiAxios.get("address?contactId=" + payload.contactId);

    let addressList = [];
    
    let address1 = {};
    address1.contactMethodId = "1";
    address1.addressLine1 = "74 Dale Ave";
    address1.city = "Toronto";
    address1.countryRegion = "ON";
    address1.PostalZipCode = "M5R 1P6";
    addressList.push(address1);
    let address2 = {};
    address2.contactMethodId = "2";
    address2.organization = "Ontario Dental Association";
    address2.addressLine1 = "4 New Street";
    address2.city = "Toronto";
    address2.countryRegion = "ON";
    address2.PostalZipCode = "M5R 1P6";
    addressList.push(address2);
    let address3 = {};
    address3.contactMethodId = "3";
    address3.addressLine1 = "100 Front St W";
    address3.city = "Toronto";
    address3.countryRegion = "ON";
    address3.PostalZipCode = "M5J 1E3";
    addressList.push(address3);    
    
    return  {
            addressList: addressList,
            message: null,
        }        
    } catch (error) {
        return {
            contact: null,
            message: 'Failed to get contact. ' + error
        }
    }
}



function* getAddressList({ payload }) {
    try {
        const returnedData = yield call(getAddressListAsync, payload);
        if (!returnedData.message) {
            yield put(getAddressListSuccess(returnedData.addressList));
        } else {
            yield put(getAddressListError(returnedData.message));
        }
    } catch (error) {
        yield put(getAddressListError(error));
    }
}



export default function* rootSaga() {
    yield all([
        fork(watchGetAddressList)
    ]);
}